define('models/base/modal',['require','models/base/model'],function(require) {
    'use strict';

    var Model = require('models/base/model');

    var ModalModel = Model.extend({
        defaults: {
            title: 'Заголовок',
            buttons: [
                { caption: 'Нет', className: '', 'action': 'cancel' },
                { caption: 'Да', className: 'btn-primary', 'action': 'submit' }
            ],
            body: '',
            showFooter: true
        }
    });

    return ModalModel;
});

